import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { TransferState, StateKey, makeStateKey } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';


/** copy from https://andremonteiro.pt/ngx-translate-angular-universal-ssr/ */
export class TranslateBrowserLoaderService implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private transferState: TransferState,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const key: StateKey<number> = makeStateKey<number>(
      'transfer-translate-' + lang
    );
    const data = this.transferState.get(key, null);

    // First we are looking for the translations in transfer-state,
    // if none found, http load as fallback
    if (data) {
      return new Observable((observer) => {
        observer.next(data);
        observer.complete();
      });
    } else {
      const baseHref = this.document.head.getElementsByTagName('base')[0].getAttribute('href');
      return this.http.get(`${baseHref}assets/i18n/${lang}.json`);
      // return new TranslateHttpLoader(this.http).getTranslation(lang);
    }
  }
}

export function translateBrowserLoaderFactory(
  httpClient: HttpClient,
  transferState: TransferState,
  document: Document,
) {
  return new TranslateBrowserLoaderService(httpClient, transferState, document);
}
